export const versionConfig = {
  version: "1.0.25",
  buildDate: "2026-07-23",
  changelog: `
- Add ASIN Profitability Report with COGS, FBA Inventory Planning, and DataKiosk Traffic data sources
- Add break-even ACoS, contribution margin, and max profitable CPA metrics to ASIN report
- Add TACoS metric with trend charting to ASIN report detail and economics summary
- Add Search Term Report ingestion
- Add Excel export for ASIN profitability report
- Add cancel and retry actions for stuck or failed ASIN report steps
- Fix duplicate ASIN crash in DataKiosk traffic import
- Fix race condition in ASIN report combine
  `,
  showNotification: true,
  forceReset: false,
  softReset: true
}

// Backward compatibility exports
export const version = versionConfig.version
export const buildDate = versionConfig.buildDate
